import React from 'react';
import { Icon as VoltoIcon } from '@plone/volto/components';
import config from '@plone/volto/registry';

import LinkIcon from '@plone/volto/icons/link.svg';
import HomeIcon from '@plone/volto/icons/home.svg';
import FolderIcon from '@plone/volto/icons/folder.svg';
import UserIcon from '@plone/volto/icons/user.svg';
import PencilIcon from '@plone/volto/icons/pencil.svg';

const iconChoices = {
  link: LinkIcon,
  home: HomeIcon,
  folder: FolderIcon,
  user: UserIcon,
  pencil: PencilIcon,
};

const getHref = (href) => {
  if (!href) return '#';
  if (typeof href === 'string') return href;
  if (Array.isArray(href)) return href[0]?.['@id'] || '#';
  return href['@id'] || '#';
};

const isExternalLink = (href) => {
  if (!href || typeof href !== 'string') return false;
  if (href.startsWith('/')) return false;
  if (href.startsWith(config.settings.apiPath)) return false;
  return href.startsWith('http');
};

const View = ({ data }) => {
  const buttonHref = getHref(data.buttonLink);
  const showButton = data.showButton || !!data.buttonLabel;
  const buttonIsExternal = isExternalLink(buttonHref);

  return (
    <div className="icon-link-row-view" style={{ textAlign: 'center' }}>
      {data.header && <h2 style={{ marginBottom: '1rem' }}>{data.header}</h2>}
      <div
        style={{
          display: 'flex',
          gap: '2rem',
          flexWrap: 'wrap',
          justifyContent: 'center',
        }}
      >
        {(data.items || []).map((item, index) => {
          const IconComponent = iconChoices[item.icon] || LinkIcon;
          const resolvedHref = getHref(item.href);
          const isExternal = isExternalLink(resolvedHref);
          return (
            <div key={index} style={{ textAlign: 'center', minWidth: '80px' }}>
              <a
                href={resolvedHref}
                target={isExternal ? '_blank' : '_self'}
                rel={isExternal ? 'noopener noreferrer' : undefined}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <VoltoIcon name={IconComponent} size="30px" />
                <span style={{ marginTop: '0.5rem' }}>{item.text}</span>
              </a>
            </div>
          );
        })}
      </div>
      {showButton && buttonHref && (
        <div style={{ marginTop: '2rem' }}>
          <a
            href={buttonHref}
            target={buttonIsExternal ? '_blank' : '_self'}
            rel={buttonIsExternal ? 'noopener noreferrer' : undefined}
            className="ui primary button"
          >
            {data.buttonLabel || 'Click here'}
          </a>
        </div>
      )}
    </div>
  );
};

export default View;
